export default __webpack_public_path__ + "static/media/jodacare-logo-liggende.b75d7b67.png";